module.exports = __webpack_public_path__ + "static/media/signup.ac234059.png";